import { connect } from "react-redux";
import CreditRatingTerms from "src/components/CreditRatingTerms/CreditRatingTerms";
import { ApplicationStore } from "src/store";

function mapStateToProps({ account }: ApplicationStore) {
    return {
        accountName: account.name,
    };
}

export default connect(mapStateToProps)(CreditRatingTerms);
